import React from 'react';

import { Resolver } from 'craft/types';

import { RTENode } from '../RTENode';

export const Typography: Resolver = (props: any) => {
  const { variant } = props.element.data;

  const Comp = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p'].includes(
    variant?.toLowerCase() ?? '',
  )
    ? variant?.toLowerCase()
    : 'p';

  return <RTENode is={Comp} {...props} />;
};
